export const BaseRouteUrl = '/edatlink-admin';

const BASEURLCONFIG = {

  ISWAN_IE_URL: '/iswan-ie-service',
  ISWAN_IC_URL: '/iswan-ic-service',
  enterpriseCodeForDev: '18047211111',
//   enterpriseCodeForDev: '19552759330_1vwdu5',
  // enterpriseCodeForDev: '18047213715-5rdf1x',
  // enterpriseCodeForDev: '17727937593-yh3u2l',
  //enterpriseCodeForDev:'cloud7f',
  //enterpriseCodeForDev:'yuanmei',
  ISWAN_BASE_URL: '/iswan-base-service',
  ISWAN_MES_URL: '/iswan-mes-service',
  ISWAN_AI_URL: '/iswan-ai-service',
  ISWAN_FIRE_URL: '/iswan-fire-service',
  ISWAN_MONITOR_URL: '/iswan-monitor-service',
  ISWAN_MONITOR_ENGINE_URL: '/iswan-monitor-engine-service',
  ISWAN_DEVICE_REMOTE_URL:'/deviceApi',
  ISWAN_IPR_URL: '/iswan-ipr-service',
  WS_LOCAL_URL:'https://cloud7f.prod.iswan.cc/ws',
  sso_login_url:
    process.env.NODE_ENV === 'development' ? BaseRouteUrl + '/user/login' : BaseRouteUrl + '/user/login',
};
export default BASEURLCONFIG;
